<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <CascadeAccessView/>
  </div>
</template>

<script>
import CascadeAccessView from "./CascadeAccessView";

export default {
  name: 'CascadeAccess',
  middleware: ['auth'],
  components: {
    CascadeAccessView
  }
}
</script>
